export const dashboardData = {
  "kpis": {
    "totalClaims": 14616,
    "completed": 7145,
    "failed": 7471,
    "successRate": 48.9,
    "totalUploaded": 154603,
    "relevantImages": 78820,
    "partsIdentified": 389609,
    "partsNotIdentified": 174586
  },
  "monthlyTrend": [
    {
      "month": "2022-04",
      "completed": 0,
      "failed": 74,
      "total": 74
    },
    {
      "month": "2022-05",
      "completed": 0,
      "failed": 110,
      "total": 110
    },
    {
      "month": "2022-06",
      "completed": 0,
      "failed": 59,
      "total": 59
    },
    {
      "month": "2022-07",
      "completed": 0,
      "failed": 63,
      "total": 63
    },
    {
      "month": "2022-08",
      "completed": 0,
      "failed": 109,
      "total": 109
    },
    {
      "month": "2022-09",
      "completed": 0,
      "failed": 109,
      "total": 109
    },
    {
      "month": "2022-10",
      "completed": 0,
      "failed": 62,
      "total": 62
    },
    {
      "month": "2022-11",
      "completed": 0,
      "failed": 106,
      "total": 106
    },
    {
      "month": "2022-12",
      "completed": 0,
      "failed": 94,
      "total": 94
    },
    {
      "month": "2023-01",
      "completed": 0,
      "failed": 96,
      "total": 96
    },
    {
      "month": "2023-02",
      "completed": 0,
      "failed": 81,
      "total": 81
    },
    {
      "month": "2023-03",
      "completed": 0,
      "failed": 73,
      "total": 73
    },
    {
      "month": "2023-04",
      "completed": 0,
      "failed": 59,
      "total": 59
    },
    {
      "month": "2023-05",
      "completed": 0,
      "failed": 93,
      "total": 93
    },
    {
      "month": "2023-06",
      "completed": 0,
      "failed": 98,
      "total": 98
    },
    {
      "month": "2023-07",
      "completed": 0,
      "failed": 70,
      "total": 70
    },
    {
      "month": "2023-08",
      "completed": 0,
      "failed": 96,
      "total": 96
    },
    {
      "month": "2023-09",
      "completed": 0,
      "failed": 111,
      "total": 111
    },
    {
      "month": "2023-10",
      "completed": 0,
      "failed": 163,
      "total": 163
    },
    {
      "month": "2023-11",
      "completed": 0,
      "failed": 156,
      "total": 156
    },
    {
      "month": "2023-12",
      "completed": 0,
      "failed": 165,
      "total": 165
    },
    {
      "month": "2024-01",
      "completed": 0,
      "failed": 133,
      "total": 133
    },
    {
      "month": "2024-02",
      "completed": 0,
      "failed": 93,
      "total": 93
    },
    {
      "month": "2024-03",
      "completed": 0,
      "failed": 91,
      "total": 91
    },
    {
      "month": "2024-04",
      "completed": 0,
      "failed": 100,
      "total": 100
    },
    {
      "month": "2024-05",
      "completed": 0,
      "failed": 115,
      "total": 115
    },
    {
      "month": "2024-06",
      "completed": 0,
      "failed": 121,
      "total": 121
    },
    {
      "month": "2024-07",
      "completed": 0,
      "failed": 105,
      "total": 105
    },
    {
      "month": "2024-08",
      "completed": 0,
      "failed": 131,
      "total": 131
    },
    {
      "month": "2024-09",
      "completed": 0,
      "failed": 131,
      "total": 131
    },
    {
      "month": "2024-10",
      "completed": 0,
      "failed": 140,
      "total": 140
    },
    {
      "month": "2024-11",
      "completed": 0,
      "failed": 98,
      "total": 98
    },
    {
      "month": "2024-12",
      "completed": 0,
      "failed": 127,
      "total": 127
    },
    {
      "month": "2025-01",
      "completed": 0,
      "failed": 117,
      "total": 117
    },
    {
      "month": "2025-02",
      "completed": 0,
      "failed": 71,
      "total": 71
    },
    {
      "month": "2025-03",
      "completed": 0,
      "failed": 85,
      "total": 85
    },
    {
      "month": "2025-04",
      "completed": 0,
      "failed": 113,
      "total": 113
    },
    {
      "month": "2025-05",
      "completed": 0,
      "failed": 134,
      "total": 134
    },
    {
      "month": "2025-06",
      "completed": 0,
      "failed": 200,
      "total": 200
    },
    {
      "month": "2025-07",
      "completed": 0,
      "failed": 231,
      "total": 231
    },
    {
      "month": "2025-08",
      "completed": 0,
      "failed": 299,
      "total": 299
    },
    {
      "month": "2025-09",
      "completed": 0,
      "failed": 218,
      "total": 218
    },
    {
      "month": "2025-10",
      "completed": 0,
      "failed": 287,
      "total": 287
    },
    {
      "month": "2025-11",
      "completed": 0,
      "failed": 191,
      "total": 191
    },
    {
      "month": "2025-12",
      "completed": 0,
      "failed": 230,
      "total": 230
    },
    {
      "month": "2026-01",
      "completed": 0,
      "failed": 318,
      "total": 318
    },
    {
      "month": "2026-02",
      "completed": 0,
      "failed": 357,
      "total": 357
    },
    {
      "month": "2026-03",
      "completed": 0,
      "failed": 272,
      "total": 272
    },
    {
      "month": "2026-04",
      "completed": 387,
      "failed": 265,
      "total": 652
    },
    {
      "month": "2026-05",
      "completed": 1874,
      "failed": 447,
      "total": 2321
    },
    {
      "month": "2026-06",
      "completed": 4884,
      "failed": 204,
      "total": 5088
    }
  ],
  "statusDist": [
    {
      "status": "Completed",
      "count": 7145,
      "fill": "#22c55e"
    },
    {
      "status": "Failed",
      "count": 7471,
      "fill": "#ef4444"
    }
  ],
  "makeData": [
    {
      "make": "Maruti Suzuki",
      "count": 2795,
      "completed": 2153,
      "failed": 642
    },
    {
      "make": "Hyundai",
      "count": 1840,
      "completed": 1182,
      "failed": 658
    },
    {
      "make": "Kia",
      "count": 985,
      "completed": 640,
      "failed": 345
    },
    {
      "make": "Toyota",
      "count": 824,
      "completed": 491,
      "failed": 333
    },
    {
      "make": "Tata",
      "count": 448,
      "completed": 388,
      "failed": 60
    },
    {
      "make": "Honda",
      "count": 369,
      "completed": 252,
      "failed": 117
    },
    {
      "make": "Renault",
      "count": 274,
      "completed": 195,
      "failed": 79
    },
    {
      "make": "Suzuki",
      "count": 270,
      "completed": 137,
      "failed": 133
    },
    {
      "make": "Volkswagen",
      "count": 263,
      "completed": 169,
      "failed": 94
    },
    {
      "make": "Mahindra",
      "count": 254,
      "completed": 195,
      "failed": 59
    },
    {
      "make": "Ford",
      "count": 228,
      "completed": 123,
      "failed": 105
    },
    {
      "make": "Skoda",
      "count": 213,
      "completed": 174,
      "failed": 39
    }
  ],
  "modelData": [
    {
      "model": "Swift",
      "count": 560
    },
    {
      "model": "Baleno",
      "count": 395
    },
    {
      "model": "Creta",
      "count": 369
    },
    {
      "model": "Seltos",
      "count": 358
    },
    {
      "model": "Dzire",
      "count": 356
    },
    {
      "model": "Wagon R",
      "count": 347
    },
    {
      "model": "Sonet",
      "count": 315
    },
    {
      "model": "i20",
      "count": 310
    },
    {
      "model": "Ertiga",
      "count": 279
    },
    {
      "model": "Grand i10",
      "count": 203
    },
    {
      "model": "Venue",
      "count": 178
    },
    {
      "model": "Nexon",
      "count": 173
    },
    {
      "model": "Harrier",
      "count": 132
    },
    {
      "model": "Carens",
      "count": 117
    },
    {
      "model": "Vitara Brezza",
      "count": 109
    }
  ],
  "userPerf": [
    {
      "user": "ClaimsApp",
      "email": "ClaimsApp",
      "total": 626,
      "completed": 356,
      "failed": 270,
      "rate": 56.9
    },
    {
      "user": "didesh.poojary",
      "email": "didesh.poojary@bajajallianz.co.in",
      "total": 231,
      "completed": 15,
      "failed": 216,
      "rate": 6.5
    },
    {
      "user": "ruchinmangla.ext",
      "email": "ruchinmangla.ext@surveyor.com",
      "total": 177,
      "completed": 29,
      "failed": 148,
      "rate": 16.4
    },
    {
      "user": "mohan.moorthi",
      "email": "mohan.moorthi@bajajallianz.co.in",
      "total": 155,
      "completed": 17,
      "failed": 138,
      "rate": 11.0
    },
    {
      "user": "mahafeez.ext",
      "email": "mahafeez.ext@surveyor.com",
      "total": 143,
      "completed": 10,
      "failed": 133,
      "rate": 7.0
    },
    {
      "user": "dipendrasingh.rao",
      "email": "dipendrasingh.rao@bajajallianz.co.in",
      "total": 142,
      "completed": 14,
      "failed": 128,
      "rate": 9.9
    },
    {
      "user": "amritpal.singh08",
      "email": "amritpal.singh08@bajajallianz.co.in",
      "total": 138,
      "completed": 8,
      "failed": 130,
      "rate": 5.8
    },
    {
      "user": "rajatgupta.ext",
      "email": "rajatgupta.ext@surveyor.com",
      "total": 133,
      "completed": 2,
      "failed": 131,
      "rate": 1.5
    },
    {
      "user": "bhanuprakash.ts",
      "email": "bhanuprakash.ts@bajajallianz.co.in",
      "total": 122,
      "completed": 28,
      "failed": 94,
      "rate": 23.0
    },
    {
      "user": "dhritikiawagholi.r",
      "email": "dhritikiawagholi.rep@repairer.com",
      "total": 122,
      "completed": 5,
      "failed": 117,
      "rate": 4.1
    },
    {
      "user": "ashutosh.deepak",
      "email": "ashutosh.deepak@bajajallianz.co.in",
      "total": 101,
      "completed": 6,
      "failed": 95,
      "rate": 5.9
    },
    {
      "user": "sumitkumar.patel",
      "email": "sumitkumar.patel@bajajallianz.co.in",
      "total": 101,
      "completed": 22,
      "failed": 79,
      "rate": 21.8
    },
    {
      "user": "upadesh.chhapola",
      "email": "upadesh.chhapola@bajajallianz.co.in",
      "total": 97,
      "completed": 13,
      "failed": 84,
      "rate": 13.4
    },
    {
      "user": "koushik.das02",
      "email": "koushik.das02@bajajallianz.co.in",
      "total": 83,
      "completed": 1,
      "failed": 82,
      "rate": 1.2
    },
    {
      "user": "gobinda.santra",
      "email": "gobinda.santra@bajajallianz.co.in",
      "total": 82,
      "completed": 18,
      "failed": 64,
      "rate": 22.0
    },
    {
      "user": "vishpendra.bhagaur",
      "email": "vishpendra.bhagaur@bajajallianz.co.in",
      "total": 78,
      "completed": 17,
      "failed": 61,
      "rate": 21.8
    },
    {
      "user": "swakshar.paladhi",
      "email": "swakshar.paladhi@bajajallianz.co.in",
      "total": 77,
      "completed": 73,
      "failed": 4,
      "rate": 94.8
    },
    {
      "user": "chetanmehta.ext",
      "email": "chetanmehta.ext@surveyor.com",
      "total": 75,
      "completed": 9,
      "failed": 66,
      "rate": 12.0
    },
    {
      "user": "ravinduavalahalli.",
      "email": "ravinduavalahalli.rep@repairer.com",
      "total": 74,
      "completed": 0,
      "failed": 74,
      "rate": 0.0
    },
    {
      "user": "divakara.k",
      "email": "divakara.k@bajajallianz.co.in",
      "total": 73,
      "completed": 28,
      "failed": 45,
      "rate": 38.4
    }
  ],
  "cameraData": [
    {
      "angle": "Front",
      "pct": 58.0,
      "count": 8476
    },
    {
      "angle": "Rear",
      "pct": 52.2,
      "count": 7634
    },
    {
      "angle": "Left",
      "pct": 33.5,
      "count": 4891
    },
    {
      "angle": "Right",
      "pct": 32.1,
      "count": 4692
    },
    {
      "angle": "Front Left",
      "pct": 62.0,
      "count": 9060
    },
    {
      "angle": "Front Right",
      "pct": 65.6,
      "count": 9588
    },
    {
      "angle": "Rear Left",
      "pct": 66.1,
      "count": 9657
    },
    {
      "angle": "Rear Right",
      "pct": 66.0,
      "count": 9646
    }
  ],
  "imgTrend": [
    {
      "month": "2022-04",
      "uploaded": 786,
      "relevant": 102
    },
    {
      "month": "2022-05",
      "uploaded": 1157,
      "relevant": 95
    },
    {
      "month": "2022-06",
      "uploaded": 653,
      "relevant": 99
    },
    {
      "month": "2022-07",
      "uploaded": 696,
      "relevant": 90
    },
    {
      "month": "2022-08",
      "uploaded": 1122,
      "relevant": 164
    },
    {
      "month": "2022-09",
      "uploaded": 1103,
      "relevant": 113
    },
    {
      "month": "2022-10",
      "uploaded": 643,
      "relevant": 94
    },
    {
      "month": "2022-11",
      "uploaded": 1092,
      "relevant": 113
    },
    {
      "month": "2022-12",
      "uploaded": 1062,
      "relevant": 181
    },
    {
      "month": "2023-01",
      "uploaded": 1041,
      "relevant": 148
    },
    {
      "month": "2023-02",
      "uploaded": 903,
      "relevant": 153
    },
    {
      "month": "2023-03",
      "uploaded": 778,
      "relevant": 93
    },
    {
      "month": "2023-04",
      "uploaded": 667,
      "relevant": 52
    },
    {
      "month": "2023-05",
      "uploaded": 935,
      "relevant": 113
    },
    {
      "month": "2023-06",
      "uploaded": 1044,
      "relevant": 171
    },
    {
      "month": "2023-07",
      "uploaded": 747,
      "relevant": 191
    },
    {
      "month": "2023-08",
      "uploaded": 1050,
      "relevant": 225
    },
    {
      "month": "2023-09",
      "uploaded": 1213,
      "relevant": 263
    },
    {
      "month": "2023-10",
      "uploaded": 1651,
      "relevant": 493
    },
    {
      "month": "2023-11",
      "uploaded": 1625,
      "relevant": 659
    },
    {
      "month": "2023-12",
      "uploaded": 1795,
      "relevant": 812
    },
    {
      "month": "2024-01",
      "uploaded": 1444,
      "relevant": 626
    },
    {
      "month": "2024-02",
      "uploaded": 1132,
      "relevant": 507
    },
    {
      "month": "2024-03",
      "uploaded": 1007,
      "relevant": 374
    },
    {
      "month": "2024-04",
      "uploaded": 1150,
      "relevant": 329
    },
    {
      "month": "2024-05",
      "uploaded": 1280,
      "relevant": 209
    },
    {
      "month": "2024-06",
      "uploaded": 1363,
      "relevant": 469
    },
    {
      "month": "2024-07",
      "uploaded": 1157,
      "relevant": 462
    },
    {
      "month": "2024-08",
      "uploaded": 1404,
      "relevant": 762
    },
    {
      "month": "2024-09",
      "uploaded": 1408,
      "relevant": 668
    },
    {
      "month": "2024-10",
      "uploaded": 1497,
      "relevant": 653
    },
    {
      "month": "2024-11",
      "uploaded": 1037,
      "relevant": 303
    },
    {
      "month": "2024-12",
      "uploaded": 1314,
      "relevant": 494
    },
    {
      "month": "2025-01",
      "uploaded": 1241,
      "relevant": 457
    },
    {
      "month": "2025-02",
      "uploaded": 767,
      "relevant": 276
    },
    {
      "month": "2025-03",
      "uploaded": 934,
      "relevant": 271
    },
    {
      "month": "2025-04",
      "uploaded": 1187,
      "relevant": 287
    },
    {
      "month": "2025-05",
      "uploaded": 1463,
      "relevant": 306
    },
    {
      "month": "2025-06",
      "uploaded": 2551,
      "relevant": 324
    },
    {
      "month": "2025-07",
      "uploaded": 2652,
      "relevant": 608
    },
    {
      "month": "2025-08",
      "uploaded": 3322,
      "relevant": 372
    },
    {
      "month": "2025-09",
      "uploaded": 2458,
      "relevant": 353
    },
    {
      "month": "2025-10",
      "uploaded": 3090,
      "relevant": 449
    },
    {
      "month": "2025-11",
      "uploaded": 2215,
      "relevant": 454
    },
    {
      "month": "2025-12",
      "uploaded": 2513,
      "relevant": 624
    },
    {
      "month": "2026-01",
      "uploaded": 3399,
      "relevant": 851
    },
    {
      "month": "2026-02",
      "uploaded": 3794,
      "relevant": 1208
    },
    {
      "month": "2026-03",
      "uploaded": 2919,
      "relevant": 826
    },
    {
      "month": "2026-04",
      "uploaded": 6811,
      "relevant": 3894
    },
    {
      "month": "2026-05",
      "uploaded": 24084,
      "relevant": 17191
    },
    {
      "month": "2026-06",
      "uploaded": 52247,
      "relevant": 39789
    }
  ],
  "partsData": [
    {
      "name": "Identified",
      "value": 389609,
      "fill": "#3b82f6"
    },
    {
      "name": "Not Identified",
      "value": 174586,
      "fill": "#f97316"
    }
  ],
  "failMakeData": [
    {
      "make": "Fiat",
      "total": 66,
      "failed": 44,
      "failRate": 66.7
    },
    {
      "make": "Jeep",
      "total": 73,
      "failed": 44,
      "failRate": 60.3
    },
    {
      "make": "Land Rover",
      "total": 55,
      "failed": 33,
      "failRate": 60.0
    },
    {
      "make": "Tata Motors Limited",
      "total": 113,
      "failed": 65,
      "failRate": 57.5
    },
    {
      "make": "Chevrolet",
      "total": 69,
      "failed": 37,
      "failRate": 53.6
    },
    {
      "make": "Opel",
      "total": 75,
      "failed": 40,
      "failRate": 53.3
    },
    {
      "make": "Peugeot",
      "total": 64,
      "failed": 34,
      "failRate": 53.1
    },
    {
      "make": "Lada",
      "total": 37,
      "failed": 19,
      "failRate": 51.4
    },
    {
      "make": "Lexus",
      "total": 69,
      "failed": 35,
      "failRate": 50.7
    },
    {
      "make": "Suzuki",
      "total": 270,
      "failed": 133,
      "failRate": 49.3
    }
  ],
  "tableData": [
    {
      "claimId": "OC-23-1101-1825-00000025",
      "createdAt": "2022-04-01 12:19",
      "user": "ruchinmangla.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-2001-1801-00000725",
      "createdAt": "2022-04-21 19:45",
      "user": "hari",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1901-1801-00001627",
      "createdAt": "2022-05-09 16:58",
      "user": "lakozytoyotavasai.",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1401-1825-00000318",
      "createdAt": "2022-05-20 13:56",
      "user": "galaxykiakota.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1801-1827-00000337",
      "createdAt": "2022-06-06 19:18",
      "user": "dcharsha521",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 43,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1301-1801-00000759",
      "createdAt": "2022-06-29 12:58",
      "user": "gurvinder.singh10",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 12,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-2003-1801-00000590",
      "createdAt": "2022-07-20 18:34",
      "user": "santosh.chandele",
      "make": "Maruti Suzuki",
      "model": "Swift Dzire",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 3,
      "cameras": 5
    },
    {
      "claimId": "OC-23-2001-1801-00004186",
      "createdAt": "2022-08-12 12:24",
      "user": "trishulservicestat",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1701-1825-00001653",
      "createdAt": "2022-08-25 15:20",
      "user": "kalyanibgroad.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-2401-1801-00005957",
      "createdAt": "2022-09-07 10:39",
      "user": "pinaclehondakolkat",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1302-1801-00002147",
      "createdAt": "2022-09-17 16:36",
      "user": "ananddixit.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1701-1801-00004553",
      "createdAt": "2022-10-04 15:12",
      "user": "sudheer.g",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1801-1825-00004333",
      "createdAt": "2022-10-21 12:44",
      "user": "rksnampally.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1401-1801-00003390",
      "createdAt": "2022-11-09 20:49",
      "user": "mohitkushawa.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-2301-1825-00001035",
      "createdAt": "2022-11-24 14:43",
      "user": "shivendra.gupta",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1103-1801-00012426",
      "createdAt": "2022-12-10 11:37",
      "user": "ruchinmangla.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1103-1801-00013156",
      "createdAt": "2022-12-24 11:35",
      "user": "ruchinmangla.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1701-1825-00003230",
      "createdAt": "2023-01-09 18:17",
      "user": "Sampath.Kumar03",
      "make": "Kia",
      "model": "Sonet",
      "status": "Failed",
      "uploaded": 20,
      "relevant": 13,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-23-2204-1801-00003841",
      "createdAt": "2023-01-24 16:12",
      "user": "vikas.rakholiya",
      "make": "Mahindra",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 39,
      "partsNot": 4,
      "cameras": 7
    },
    {
      "claimId": "OC-23-2001-1870-00003486",
      "createdAt": "2023-02-09 17:42",
      "user": "dhritikiawagholi.r",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1801-1803-00000818",
      "createdAt": "2023-02-28 12:51",
      "user": "kakatiyawgl.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-23-1701-1801-00008171",
      "createdAt": "2023-03-16 15:57",
      "user": "ravinduavalahalli.",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2401-1870-00000273",
      "createdAt": "2023-04-13 16:32",
      "user": "rajatgupta.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2001-1801-00000880",
      "createdAt": "2023-05-04 13:52",
      "user": "akash.dhumal01",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2401-1801-00001674",
      "createdAt": "2023-05-23 09:58",
      "user": "rajatgupta.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2001-1801-00001856",
      "createdAt": "2023-06-05 11:17",
      "user": "vijay.daphale",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2001-1801-00002532",
      "createdAt": "2023-06-20 18:02",
      "user": "dhritikiawagholi.r",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2404-1825-00000278",
      "createdAt": "2023-07-05 20:23",
      "user": "ajinmoy.das",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1802-1801-00000839",
      "createdAt": "2023-07-23 13:14",
      "user": "mahafeez.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1701-1870-00000785",
      "createdAt": "2023-08-11 15:13",
      "user": "raghavendra.mg",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1802-1801-00001150",
      "createdAt": "2023-08-28 15:58",
      "user": "mgbrotherskiaantp.",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2204-1801-00002215",
      "createdAt": "2023-09-12 09:58",
      "user": "nirav.devmurari",
      "make": "Maruti Suzuki",
      "model": "Ciaz",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 7
    },
    {
      "claimId": "OC-24-1702-1825-00000528",
      "createdAt": "2023-09-22 16:18",
      "user": "abharana.rep",
      "make": "Maruti Suzuki",
      "model": "Wagon R",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 36,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-24-1203-1801-00000815",
      "createdAt": "2023-10-05 15:01",
      "user": "ravinder.singh07",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1901-1801-00006412",
      "createdAt": "2023-10-13 14:41",
      "user": "bhupesh.shinde",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 37,
      "partsNot": 5,
      "cameras": 4
    },
    {
      "claimId": "OC-24-1201-1825-00001962",
      "createdAt": "2023-10-21 15:45",
      "user": "bbchawla.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2003-1801-00001176",
      "createdAt": "2023-11-01 14:26",
      "user": "chaudharicars.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1503-1801-00001156",
      "createdAt": "2023-11-10 13:11",
      "user": "jaiganesh.p",
      "make": "Maruti Suzuki",
      "model": "Swift",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 10,
      "partsId": 28,
      "partsNot": 8,
      "cameras": 5
    },
    {
      "claimId": "OC-24-2202-1801-00006406",
      "createdAt": "2023-11-21 15:55",
      "user": "paraskumarsuthar.e",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 33,
      "partsNot": 6,
      "cameras": 5
    },
    {
      "claimId": "OC-24-1103-1801-00010220",
      "createdAt": "2023-11-28 17:29",
      "user": "ClaimsApp",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-24-1205-1801-00002273",
      "createdAt": "2023-12-07 13:31",
      "user": "tazeem.shah",
      "make": "Jeep",
      "model": "Compass",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 27,
      "partsNot": 12,
      "cameras": 4
    },
    {
      "claimId": "OC-24-2001-1801-00007958",
      "createdAt": "2023-12-19 16:54",
      "user": "sonaktoyota.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 5,
      "partsId": 37,
      "partsNot": 5,
      "cameras": 5
    },
    {
      "claimId": "OC-24-2001-1801-00008136",
      "createdAt": "2023-12-26 15:36",
      "user": "ClaimsApp",
      "make": "Honda",
      "model": "City",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 4,
      "cameras": 7
    },
    {
      "claimId": "OC-24-1101-1801-00007887",
      "createdAt": "2024-01-04 13:04",
      "user": "dsgaba.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 15,
      "relevant": 3,
      "partsId": 9,
      "partsNot": 23,
      "cameras": 1
    },
    {
      "claimId": "OC-24-1101-1870-00003404",
      "createdAt": "2024-01-16 14:22",
      "user": "vikasbararia.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1702-1801-00001075",
      "createdAt": "2024-01-25 14:47",
      "user": "abharana.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1204-1801-00001029",
      "createdAt": "2024-02-07 11:54",
      "user": "rahul.kashyap",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-1103-1825-00012503",
      "createdAt": "2024-02-22 18:03",
      "user": "ajay.kumar44",
      "make": "Kia",
      "model": "Seltos",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 9,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-24-1901-1801-00011242",
      "createdAt": "2024-03-07 18:25",
      "user": "saiservicepalghar.",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 1,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-24-2003-1801-00001973",
      "createdAt": "2024-03-24 13:33",
      "user": "rajendrakotkar6763",
      "make": "Maruti Suzuki",
      "model": "Celerio",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 16,
      "partsNot": 16,
      "cameras": 3
    },
    {
      "claimId": "OC-25-2001-1801-00000345",
      "createdAt": "2024-04-12 10:58",
      "user": "shawtoyota.rep",
      "make": "Toyota",
      "model": "Innova Crysta",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 4,
      "partsId": 31,
      "partsNot": 9,
      "cameras": 3
    },
    {
      "claimId": "OC-25-2301-1870-00000060",
      "createdAt": "2024-04-26 17:04",
      "user": "pramod.prasad",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-2405-1870-00000173",
      "createdAt": "2024-05-06 12:47",
      "user": "nitumoni.hazarika",
      "make": "Hyundai",
      "model": "Venue",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-1701-1801-00001290",
      "createdAt": "2024-05-23 13:07",
      "user": "nandibanasawadi.re",
      "make": "Toyota",
      "model": "Camry",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-2401-1801-00002146",
      "createdAt": "2024-06-04 18:50",
      "user": "rajatgupta.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 8,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-2001-1801-00002717",
      "createdAt": "2024-06-17 13:08",
      "user": "akashashoksingh",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 52,
      "relevant": 2,
      "partsId": 7,
      "partsNot": 24,
      "cameras": 2
    },
    {
      "claimId": "OC-25-1202-1801-00000574",
      "createdAt": "2024-06-26 13:47",
      "user": "gagandeep.01",
      "make": "generic",
      "model": "Motorcycle",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-1701-1801-00002388",
      "createdAt": "2024-07-10 13:17",
      "user": "deepak.m22",
      "make": "SEAT",
      "model": "Leon",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 7,
      "partsNot": 25,
      "cameras": 1
    },
    {
      "claimId": "OC-25-2204-1801-00001746",
      "createdAt": "2024-07-25 16:33",
      "user": "rajeshthakker.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 32,
      "partsNot": 9,
      "cameras": 5
    },
    {
      "claimId": "OC-25-1109-1801-00000112",
      "createdAt": "2024-08-07 13:45",
      "user": "ashutosh.deepak",
      "make": "Hyundai",
      "model": "Grand i10",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-25-2401-1801-00004683",
      "createdAt": "2024-08-21 14:13",
      "user": "CL",
      "make": "Maruti Suzuki",
      "model": "Alto K10",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 5
    },
    {
      "claimId": "OC-25-1203-1870-00000429",
      "createdAt": "2024-08-29 12:03",
      "user": "palhyundai.rep",
      "make": "Fiat",
      "model": "Toro",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-25-2401-1801-00005271",
      "createdAt": "2024-09-09 16:51",
      "user": "CL",
      "make": "Maruti Suzuki",
      "model": "Alto K10",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-25-1109-1870-00000313",
      "createdAt": "2024-09-19 14:24",
      "user": "ashutosh.deepak",
      "make": "Hyundai",
      "model": "Creta",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 47,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-25-1401-1801-00002745",
      "createdAt": "2024-10-01 14:49",
      "user": "carglassexpert21",
      "make": "Maruti Suzuki",
      "model": "Swift",
      "status": "Failed",
      "uploaded": 19,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-25-2202-1825-00001601",
      "createdAt": "2024-10-09 15:22",
      "user": "pankil.modi03",
      "make": "Kia",
      "model": "Sonet",
      "status": "Failed",
      "uploaded": 12,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 4,
      "cameras": 6
    },
    {
      "claimId": "OC-25-1202-1801-00001158",
      "createdAt": "2024-10-21 16:00",
      "user": "deepak.basetia",
      "make": "Chevrolet",
      "model": "Matiz",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 38,
      "partsNot": 2,
      "cameras": 4
    },
    {
      "claimId": "OC-25-1205-1801-00002003",
      "createdAt": "2024-11-06 12:21",
      "user": "bhatyaseen2017",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-1301-1870-00000826",
      "createdAt": "2024-11-18 17:11",
      "user": "suraj.pandey01",
      "make": "Kia",
      "model": "Seltos",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 33,
      "partsNot": 7,
      "cameras": 3
    },
    {
      "claimId": "OC-25-1101-1870-00002776",
      "createdAt": "2024-12-03 15:48",
      "user": "b.karuppusamy",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-2101-1825-00001231",
      "createdAt": "2024-12-12 16:52",
      "user": "gaurav.waze",
      "make": "Hyundai",
      "model": "Aura",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-25-1204-1870-00000514",
      "createdAt": "2024-12-23 14:31",
      "user": "amritpal.singh08",
      "make": "Kia",
      "model": "Sonet",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 44,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-25-1109-1870-00000859",
      "createdAt": "2025-01-07 11:04",
      "user": "ashutosh.deepak",
      "make": "Hyundai",
      "model": "Santa Fe",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-25-1203-1870-00000847",
      "createdAt": "2025-01-18 14:20",
      "user": "ClaimsApp",
      "make": "generic",
      "model": "Motorcycle",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-1109-1870-00000976",
      "createdAt": "2025-02-03 13:50",
      "user": "ashutosh.deepak",
      "make": "Iveco",
      "model": "Daily",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 41,
      "partsNot": 5,
      "cameras": 6
    },
    {
      "claimId": "OC-25-2001-1801-00010452",
      "createdAt": "2025-02-17 18:47",
      "user": "geetamehta89",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-1101-1803-00006104",
      "createdAt": "2025-03-08 14:26",
      "user": "galaxymotinagar.re",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-25-1701-1825-00006656",
      "createdAt": "2025-03-25 16:34",
      "user": "advaithkia.rep",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1201-1825-00000034",
      "createdAt": "2025-04-11 13:39",
      "user": "naveen.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1901-1870-00000497",
      "createdAt": "2025-04-23 16:30",
      "user": "toyotalakozythane.",
      "make": "BMW",
      "model": "i3",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 4,
      "partsId": 25,
      "partsNot": 13,
      "cameras": 4
    },
    {
      "claimId": "OC-26-2203-1825-00000275",
      "createdAt": "2025-05-06 12:12",
      "user": "harsh.degdawala",
      "make": "Kia",
      "model": "Rio",
      "status": "Failed",
      "uploaded": 12,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1901-1825-00000812",
      "createdAt": "2025-05-16 11:52",
      "user": "arpannamotorsthane",
      "make": "Toyota",
      "model": "Innova",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-26-1705-1825-00000196",
      "createdAt": "2025-05-28 12:16",
      "user": "bhanuprakash.ts",
      "make": "Ford",
      "model": "F-150",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1109-1825-00000232",
      "createdAt": "2025-06-06 14:22",
      "user": "ashutosh.deepak",
      "make": "Hyundai",
      "model": "Tucson",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 43,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-26-1202-1825-00000386",
      "createdAt": "2025-06-16 16:00",
      "user": "nitin.gupte045",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1701-1870-00001040",
      "createdAt": "2025-06-23 10:14",
      "user": "divakara.k",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2401-1870-00001638",
      "createdAt": "2025-06-26 17:54",
      "user": "sayantan.chatterje",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1503-1870-00000618",
      "createdAt": "2025-07-03 15:42",
      "user": "jaiganesh.p",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 3,
      "partsId": 17,
      "partsNot": 19,
      "cameras": 3
    },
    {
      "claimId": "OC-26-1901-1825-00001757",
      "createdAt": "2025-07-10 16:33",
      "user": "saiservicedhanu.re",
      "make": "Hyundai",
      "model": "ix35",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2302-1825-00000197",
      "createdAt": "2025-07-16 17:46",
      "user": "parv.yadav",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 13,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1302-1803-00000661",
      "createdAt": "2025-07-22 15:46",
      "user": "shailesh.pandey",
      "make": "generic",
      "model": "Bus",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 35,
      "partsNot": 9,
      "cameras": 7
    },
    {
      "claimId": "OC-26-1705-1825-00000392",
      "createdAt": "2025-07-30 10:48",
      "user": "bhanuprakash.ts",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2301-1801-00000589",
      "createdAt": "2025-08-07 15:34",
      "user": "pramod.prasad",
      "make": "generic",
      "model": "Motorcycle",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2001-1801-00004299",
      "createdAt": "2025-08-14 16:42",
      "user": "sharayutoyota1.rep",
      "make": "Toyota",
      "model": "Innova Crysta",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 2,
      "partsId": 15,
      "partsNot": 21,
      "cameras": 2
    },
    {
      "claimId": "OC-26-1901-1801-00004566",
      "createdAt": "2025-08-21 14:56",
      "user": "harshad.panchal",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 3,
      "partsId": 11,
      "partsNot": 24,
      "cameras": 3
    },
    {
      "claimId": "OC-26-1401-1870-00001219",
      "createdAt": "2025-08-29 09:41",
      "user": "upadesh.chhapola",
      "make": "Lexus",
      "model": "UX",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 4,
      "partsId": 23,
      "partsNot": 13,
      "cameras": 4
    },
    {
      "claimId": "OC-26-1801-1870-00002805",
      "createdAt": "2025-08-29 13:42",
      "user": "suresh.singala",
      "make": "Toyota",
      "model": "RAV4",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1101-1870-00002410",
      "createdAt": "2025-08-29 16:57",
      "user": "b.karuppusamy",
      "make": "SEAT",
      "model": "Leon",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2416-1870-00000590",
      "createdAt": "2025-09-02 11:42",
      "user": "naveen.kumar014",
      "make": "Mercedes-Benz",
      "model": "C-Class",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1401-1870-00001287",
      "createdAt": "2025-09-03 10:08",
      "user": "vishpendra.bhagaur",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 12,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2405-1801-00001371",
      "createdAt": "2025-09-12 12:48",
      "user": "pritam.roy02",
      "make": "Hyundai",
      "model": "i20",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1401-1870-00001479",
      "createdAt": "2025-09-19 12:24",
      "user": "upadesh.chhapola",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1401-1825-00002340",
      "createdAt": "2025-09-29 13:30",
      "user": "dipendrasingh.rao",
      "make": "Hyundai",
      "model": "i20",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 2,
      "partsId": 10,
      "partsNot": 23,
      "cameras": 1
    },
    {
      "claimId": "OC-26-2406-1870-00000396",
      "createdAt": "2025-10-08 12:07",
      "user": "ClaimsApp",
      "make": "Ford",
      "model": "KA",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 20,
      "partsNot": 15,
      "cameras": 6
    },
    {
      "claimId": "OC-26-1901-1801-00006292",
      "createdAt": "2025-10-14 17:56",
      "user": "omkar.sonawane",
      "make": "Citroen",
      "model": "Xsara Picasso",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1705-1801-00000614",
      "createdAt": "2025-10-28 12:40",
      "user": "bhanuprakash.ts",
      "make": "Toyota",
      "model": "Innova Crysta",
      "status": "Failed",
      "uploaded": 12,
      "relevant": 5,
      "partsId": 30,
      "partsNot": 11,
      "cameras": 4
    },
    {
      "claimId": "OC-26-1702-1825-00000561",
      "createdAt": "2025-10-29 12:28",
      "user": "shivaprasada.k",
      "make": "Renault",
      "model": "Megane Sedan",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2201-1870-00001652",
      "createdAt": "2025-10-29 16:26",
      "user": "mahesh.khadas151",
      "make": "Opel",
      "model": "Grandland X",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2403-1825-00000781",
      "createdAt": "2025-10-31 09:34",
      "user": "ajit.rout",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1804-1870-00001619",
      "createdAt": "2025-11-07 12:55",
      "user": "eswarraja.kasi",
      "make": "Tata",
      "model": "Nexon",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 6
    },
    {
      "claimId": "OC-26-1901-1801-00007292",
      "createdAt": "2025-11-17 14:28",
      "user": "harshad.panchal",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1602-1801-00002362",
      "createdAt": "2025-11-21 16:17",
      "user": "aravind.j01",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 19,
      "relevant": 5,
      "partsId": 20,
      "partsNot": 17,
      "cameras": 4
    },
    {
      "claimId": "OC-26-2203-1870-00001724",
      "createdAt": "2025-11-29 22:56",
      "user": "sumitkumar.patel",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 2,
      "partsId": 9,
      "partsNot": 24,
      "cameras": 1
    },
    {
      "claimId": "OC-26-2203-1870-00001793",
      "createdAt": "2025-12-05 18:24",
      "user": "jigneshgandhi.ext",
      "make": "Hyundai",
      "model": "i20",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 2,
      "partsId": 6,
      "partsNot": 25,
      "cameras": 1
    },
    {
      "claimId": "OC-26-2406-1825-00000965",
      "createdAt": "2025-12-13 14:58",
      "user": "sanjiv.kumar05",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1702-1825-00000724",
      "createdAt": "2025-12-18 16:36",
      "user": "didesh.poojary",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 3,
      "partsId": 8,
      "partsNot": 25,
      "cameras": 3
    },
    {
      "claimId": "OC-26-2405-1801-00002257",
      "createdAt": "2025-12-26 13:20",
      "user": "pritam.roy02",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 3,
      "partsId": 7,
      "partsNot": 26,
      "cameras": 3
    },
    {
      "claimId": "OC-26-1501-1801-00003839",
      "createdAt": "2026-01-02 12:30",
      "user": "mohan.moorthi",
      "make": "Hyundai",
      "model": "i20",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 3,
      "partsId": 18,
      "partsNot": 18,
      "cameras": 2
    },
    {
      "claimId": "OC-26-1501-1825-00004089",
      "createdAt": "2026-01-08 17:18",
      "user": "mohan.moorthi",
      "make": "Renault",
      "model": "Kiger",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 4,
      "partsId": 26,
      "partsNot": 11,
      "cameras": 3
    },
    {
      "claimId": "OC-26-2203-1801-00006544",
      "createdAt": "2026-01-13 16:52",
      "user": "sumitkumar.patel",
      "make": "Honda",
      "model": "Civic",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 19,
      "partsNot": 16,
      "cameras": 4
    },
    {
      "claimId": "OC-26-1901-1803-00004356",
      "createdAt": "2026-01-14 17:26",
      "user": "simranmotorspanvel",
      "make": "Mercedes-Benz",
      "model": "C-Class",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1204-1803-00000753",
      "createdAt": "2026-01-21 13:36",
      "user": "amritpal.singh08",
      "make": "Maruti Suzuki",
      "model": "Dzire",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-26-2203-1870-00002193",
      "createdAt": "2026-01-24 14:58",
      "user": "sumitkumar.patel",
      "make": "Hyundai",
      "model": "Palisade",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 3,
      "partsId": 17,
      "partsNot": 17,
      "cameras": 2
    },
    {
      "claimId": "OC-26-1401-1801-00005208",
      "createdAt": "2026-01-29 17:47",
      "user": "dipendrasingh.rao",
      "make": "Hyundai",
      "model": "Accent",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 2,
      "partsId": 16,
      "partsNot": 18,
      "cameras": 2
    },
    {
      "claimId": "OC-26-2401-1801-00009847",
      "createdAt": "2026-02-03 13:07",
      "user": "gobinda.santra",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1109-1801-00001531",
      "createdAt": "2026-02-06 15:02",
      "user": "ashutosh.deepak",
      "make": "Hyundai",
      "model": "Venue",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-26-1702-1825-00000890",
      "createdAt": "2026-02-10 17:14",
      "user": "didesh.poojary",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 3,
      "partsId": 12,
      "partsNot": 22,
      "cameras": 3
    },
    {
      "claimId": "OC-26-1702-1825-00000895",
      "createdAt": "2026-02-13 13:23",
      "user": "didesh.poojary",
      "make": "Skoda",
      "model": "Karoq",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 2,
      "partsId": 13,
      "partsNot": 20,
      "cameras": 2
    },
    {
      "claimId": "OC-26-2406-1827-00000054",
      "createdAt": "2026-02-17 16:24",
      "user": "sanjiv.kumar05",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-2203-1825-00002752",
      "createdAt": "2026-02-20 15:22",
      "user": "sumitkumar.patel",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1501-1870-00004302",
      "createdAt": "2026-02-24 17:39",
      "user": "mohan.moorthi",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 3,
      "partsId": 13,
      "partsNot": 21,
      "cameras": 2
    },
    {
      "claimId": "OC-26-2401-1801-00010617",
      "createdAt": "2026-03-02 13:32",
      "user": "narattam.biswas",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-26-1704-1803-00000643",
      "createdAt": "2026-03-06 12:21",
      "user": "satish.gondkar",
      "make": "Maruti Suzuki",
      "model": "Dzire",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 32,
      "partsNot": 8,
      "cameras": 5
    },
    {
      "claimId": "OC-26-2203-1825-00002907",
      "createdAt": "2026-03-11 18:22",
      "user": "sumitkumar.patel",
      "make": "Maruti Suzuki",
      "model": "Celerio",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 3,
      "partsId": 19,
      "partsNot": 15,
      "cameras": 3
    },
    {
      "claimId": "OC-26-2405-1825-00001851",
      "createdAt": "2026-03-16 15:45",
      "user": "pritam.roy02",
      "make": "Toyota",
      "model": "Hilux",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 19,
      "partsNot": 15,
      "cameras": 5
    },
    {
      "claimId": "OC-26-1301-1801-00002822",
      "createdAt": "2026-03-21 14:42",
      "user": "rahul.kumar70",
      "make": "Maruti Suzuki",
      "model": "Swift Dzire",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 29,
      "partsNot": 8,
      "cameras": 5
    },
    {
      "claimId": "OC-26-1802-1801-00003330",
      "createdAt": "2026-03-25 19:44",
      "user": "mahafeez.ext",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-27-1901-1803-00000037",
      "createdAt": "2026-04-01 18:45",
      "user": "rahul.singh24",
      "make": "Hyundai",
      "model": "Aura",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 5,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2204-1801-00000066",
      "createdAt": "2026-04-03 18:04",
      "user": "nirav.devmurari",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 3,
      "partsId": 20,
      "partsNot": 14,
      "cameras": 3
    },
    {
      "claimId": "OC-27-2001-1870-00000207",
      "createdAt": "2026-04-07 13:11",
      "user": "bhushan.ranim",
      "make": "Mercedes Benz",
      "model": "GLC",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1204-1801-00000061",
      "createdAt": "2026-04-09 11:50",
      "user": "amritpal.singh08",
      "make": "generic",
      "model": "Motorcycle",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-27-1703-1801-00000107",
      "createdAt": "2026-04-13 14:46",
      "user": "sagar.lad01",
      "make": "Volkswagen",
      "model": "Polo",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1801-1803-00000339",
      "createdAt": "2026-04-15 14:46",
      "user": "godala.kishore",
      "make": "Maruti Suzuki",
      "model": "Wagon R",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 32,
      "partsNot": 7,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1501-1801-00000229",
      "createdAt": "2026-04-17 11:56",
      "user": "udayashanker.e",
      "make": "Mahindra",
      "model": "XUV700",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 45,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2001-1801-00000728",
      "createdAt": "2026-04-20 13:02",
      "user": "ClaimsApp",
      "make": "Mercedes Benz",
      "model": "GLA",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 4,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1205-1870-00000258",
      "createdAt": "2026-04-21 17:15",
      "user": "tazeem.shah",
      "make": "Maruti Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1602-1801-00000305",
      "createdAt": "2026-04-24 11:33",
      "user": "prince.abraham01",
      "make": "Chevrolet",
      "model": "Spark",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 44,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1901-1870-00000683",
      "createdAt": "2026-04-25 12:39",
      "user": "saiservicepalghar.",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-27-1401-1825-00000336",
      "createdAt": "2026-04-27 17:49",
      "user": "vishpendra.bhagaur",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 0,
      "partsId": 0,
      "partsNot": 31,
      "cameras": 0
    },
    {
      "claimId": "OC-27-2202-1801-00000957",
      "createdAt": "2026-04-28 18:41",
      "user": "ClaimsApp",
      "make": "Maruti Suzuki",
      "model": "Wagon R",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 36,
      "partsNot": 6,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1401-1801-00000539",
      "createdAt": "2026-04-30 15:25",
      "user": "paramyadav.ext",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 46,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1301-1801-00000276",
      "createdAt": "2026-05-03 01:15",
      "user": "anup.gupta",
      "make": "Hyundai",
      "model": "i20",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1401-1825-00000401",
      "createdAt": "2026-05-04 16:20",
      "user": "vishnu.kumhar03",
      "make": "Nissan",
      "model": "Magnite",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2203-1825-00000177",
      "createdAt": "2026-05-05 13:24",
      "user": "vishaltanna.ext",
      "make": "Toyota",
      "model": "Hilux",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 6,
      "partsId": 38,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2203-1801-00000862",
      "createdAt": "2026-05-06 09:45",
      "user": "Jagdishkoriya.ext",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2204-1801-00000568",
      "createdAt": "2026-05-06 17:57",
      "user": "abhay.aghera.ext",
      "make": "Maruti Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2406-1801-00000241",
      "createdAt": "2026-05-07 16:37",
      "user": "sourav.tewary",
      "make": "Maruti Suzuki",
      "model": "Vitara Brezza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2001-1825-00001228",
      "createdAt": "2026-05-08 15:21",
      "user": "akshay.jawale",
      "make": "Mitsubishi",
      "model": "Pajero Sport",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 4,
      "partsId": 32,
      "partsNot": 7,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1401-1825-00000498",
      "createdAt": "2026-05-09 09:49",
      "user": "vishpendra.bhagaur",
      "make": "Kia",
      "model": "Stonic",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1701-1801-00000833",
      "createdAt": "2026-05-11 12:15",
      "user": "ganeshprasad.ap",
      "make": "",
      "model": "",
      "status": "Failed",
      "uploaded": 13,
      "relevant": 8,
      "partsId": 30,
      "partsNot": 12,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1503-1801-00000407",
      "createdAt": "2026-05-11 18:06",
      "user": "ClaimsApp",
      "make": "Citroen",
      "model": "C5 Aircross",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2203-1870-00000309",
      "createdAt": "2026-05-12 14:37",
      "user": "Nanonets",
      "make": "Hyundai",
      "model": "Alcazar",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 46,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-27-2006-1825-00000157",
      "createdAt": "2026-05-13 10:45",
      "user": "hanmant.warwate",
      "make": "Toyota",
      "model": "Allion",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2404-1825-00000088",
      "createdAt": "2026-05-13 15:47",
      "user": "tarapada.chakrabor",
      "make": "Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1205-1825-00000149",
      "createdAt": "2026-05-14 11:29",
      "user": "sheikh.mansoor01",
      "make": "Maruti Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 26,
      "partsNot": 11,
      "cameras": 5
    },
    {
      "claimId": "OC-27-2405-1801-00000360",
      "createdAt": "2026-05-14 18:16",
      "user": "kaushik.saikia01",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 39,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2416-1825-00000190",
      "createdAt": "2026-05-15 13:03",
      "user": "vishal.singh21",
      "make": "Audi",
      "model": "Q2",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 44,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1205-1801-00000472",
      "createdAt": "2026-05-15 18:17",
      "user": "pawandeep.singh",
      "make": "Maruti Suzuki",
      "model": "Vitara Brezza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1205-1801-00000474",
      "createdAt": "2026-05-17 23:24",
      "user": "aijaz.rather",
      "make": "Maruti Suzuki",
      "model": "Alto",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2401-1801-00001372",
      "createdAt": "2026-05-18 14:53",
      "user": "chandan.sarkar01",
      "make": "Hyundai",
      "model": "i20",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 4,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2201-1870-00000501",
      "createdAt": "2026-05-18 18:50",
      "user": "amit.sharma30",
      "make": "Maruti Suzuki",
      "model": "Vitara Brezza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 44,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2001-1801-00001777",
      "createdAt": "2026-05-19 13:51",
      "user": "rohan.godase",
      "make": "Honda",
      "model": "City",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1207-1803-00000038",
      "createdAt": "2026-05-19 16:55",
      "user": "hemant.singh01",
      "make": "Maruti Suzuki",
      "model": "Vitara Brezza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 37,
      "partsNot": 6,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1109-1801-00000265",
      "createdAt": "2026-05-20 10:20",
      "user": "arunkumar1103.ext",
      "make": "Tata",
      "model": "Safari Storme",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1503-1870-00000255",
      "createdAt": "2026-05-20 14:49",
      "user": "vignesh.s02",
      "make": "Citroen",
      "model": "Basalt",
      "status": "Completed",
      "uploaded": 15,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2405-1801-00000440",
      "createdAt": "2026-05-20 17:27",
      "user": "sanjeeb.kalita",
      "make": "Honda",
      "model": "Amaze",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2001-1870-00001332",
      "createdAt": "2026-05-21 11:40",
      "user": "akshay.jawale",
      "make": "Dacia",
      "model": "Logan",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2404-1870-00000095",
      "createdAt": "2026-05-21 15:32",
      "user": "sumit.karjee",
      "make": "Kia",
      "model": "Sonet",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1401-1825-00000675",
      "createdAt": "2026-05-22 07:04",
      "user": "manojksaini.ext",
      "make": "Renault",
      "model": "Kiger",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1102-1825-00001372",
      "createdAt": "2026-05-22 13:04",
      "user": "ClaimsApp",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2204-1801-00000820",
      "createdAt": "2026-05-22 16:57",
      "user": "satish.ambaliya",
      "make": "Volkswagen",
      "model": "Vento",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 29,
      "partsNot": 10,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1503-1801-00000519",
      "createdAt": "2026-05-22 18:59",
      "user": "padmanaban.s",
      "make": "Hyundai",
      "model": "Grand i10",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 29,
      "partsNot": 9,
      "cameras": 4
    },
    {
      "claimId": "OC-27-2202-1870-00000934",
      "createdAt": "2026-05-23 17:15",
      "user": "chetanmehta.ext",
      "make": "Tata Motors Limited",
      "model": "Harrier",
      "status": "Failed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 22,
      "partsNot": 13,
      "cameras": 4
    },
    {
      "claimId": "OC-27-2401-1801-00001605",
      "createdAt": "2026-05-25 12:16",
      "user": "kartick.dey",
      "make": "Maruti Suzuki",
      "model": "Alto K10",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1109-1870-00000284",
      "createdAt": "2026-05-25 14:43",
      "user": "shashikant.ghildiy",
      "make": "Toyota",
      "model": "Innova Crysta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 29,
      "partsNot": 9,
      "cameras": 5
    },
    {
      "claimId": "OC-27-2203-1801-00001264",
      "createdAt": "2026-05-25 16:07",
      "user": "chitrang.vaniyawal",
      "make": "Maruti Suzuki",
      "model": "S-Presso",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2001-1801-00001953",
      "createdAt": "2026-05-25 19:00",
      "user": "mahesh.darwatkar",
      "make": "Toyota",
      "model": "Innova Hycross",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2001-1801-00002073",
      "createdAt": "2026-05-26 11:35",
      "user": "santosh.ambirkar",
      "make": "Hyundai",
      "model": "I20",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 4,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1901-1803-00000839",
      "createdAt": "2026-05-26 13:37",
      "user": "nabhesh.palyekar",
      "make": "Maruti Suzuki",
      "model": "Swift Dzire",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2204-1801-00000885",
      "createdAt": "2026-05-26 16:03",
      "user": "vikas.rakholiya",
      "make": "Ford",
      "model": "Figo",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1503-1870-00000272",
      "createdAt": "2026-05-26 18:50",
      "user": "jayakumar.s",
      "make": "Renault",
      "model": "Triber",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1705-1825-00000175",
      "createdAt": "2026-05-27 12:25",
      "user": "sumanth.kd",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2003-1870-00000086",
      "createdAt": "2026-05-27 14:55",
      "user": "shubham.khandare",
      "make": "Tata",
      "model": "Punch",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1701-1801-00001198",
      "createdAt": "2026-05-27 17:13",
      "user": "k.kumar02",
      "make": "Honda",
      "model": "Amaze",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 4,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1513-1801-00000039",
      "createdAt": "2026-05-28 10:19",
      "user": "vignesh.s02",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 29,
      "partsNot": 9,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1602-1801-00000860",
      "createdAt": "2026-05-28 16:12",
      "user": "srutheesh.ks",
      "make": "Hyundai",
      "model": "Grand i10",
      "status": "Failed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 5,
      "cameras": 5
    },
    {
      "claimId": "OC-27-2204-1825-00000611",
      "createdAt": "2026-05-29 12:37",
      "user": "abhay.aghera.ext",
      "make": "Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1704-1801-00000208",
      "createdAt": "2026-05-29 17:25",
      "user": "satish.gondkar",
      "make": "Hyundai",
      "model": "Venue",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 37,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1701-1801-00001228",
      "createdAt": "2026-05-30 13:59",
      "user": "venugopaln.ext",
      "make": "Honda",
      "model": "Civic",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 44,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2204-1870-00000591",
      "createdAt": "2026-06-01 11:34",
      "user": "satish.ambaliya",
      "make": "Maruti Suzuki",
      "model": "Wagon R",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 30,
      "partsNot": 8,
      "cameras": 3
    },
    {
      "claimId": "OC-27-1602-1870-00000497",
      "createdAt": "2026-06-01 12:50",
      "user": "athuldas.a",
      "make": "Hyundai",
      "model": "i30",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2201-1801-00001050",
      "createdAt": "2026-06-01 14:11",
      "user": "rajkumar.chaurasia",
      "make": "Maruti Suzuki",
      "model": "Vitara Brezza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1602-1827-00000055",
      "createdAt": "2026-06-01 15:18",
      "user": "athuldas.a",
      "make": "Toyota",
      "model": "Urban Cruiser Hyryder",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 1,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1801-1801-00001740",
      "createdAt": "2026-06-01 16:01",
      "user": "shivakumar.c02",
      "make": "Hyundai",
      "model": "Santro",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1302-1825-00000356",
      "createdAt": "2026-06-01 16:55",
      "user": "gaurav.kumar21",
      "make": "Toyota",
      "model": "Fortuner",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 45,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1802-1825-00000336",
      "createdAt": "2026-06-01 17:32",
      "user": "praveen.sydapeta",
      "make": "Tata",
      "model": "Tiago",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 36,
      "partsNot": 4,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1109-1803-00000080",
      "createdAt": "2026-06-01 18:09",
      "user": "shashikant.ghildiy",
      "make": "Maruti Suzuki",
      "model": "Dzire",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2202-1801-00002219",
      "createdAt": "2026-06-01 19:00",
      "user": "sunilkumar.prajapa",
      "make": "Volkswagen",
      "model": "Jetta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2001-1870-00001588",
      "createdAt": "2026-06-02 10:51",
      "user": "swapnil.andhare",
      "make": "MG",
      "model": "Gloster",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 45,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1109-1801-00000344",
      "createdAt": "2026-06-02 11:54",
      "user": "shashikant.ghildiy",
      "make": "Hyundai",
      "model": "Aura",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2003-1801-00000327",
      "createdAt": "2026-06-02 12:57",
      "user": "shubham.khandare",
      "make": "Maruti Suzuki",
      "model": "Swift Dzire",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 3,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1701-1825-00001246",
      "createdAt": "2026-06-02 13:46",
      "user": "akash.c01",
      "make": "Tata",
      "model": "Tiago",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2406-1825-00000309",
      "createdAt": "2026-06-02 14:27",
      "user": "dheeraj.prasad",
      "make": "Tata",
      "model": "Nexon",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 3,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1701-1803-00001541",
      "createdAt": "2026-06-02 15:25",
      "user": "manikandan.m02",
      "make": "Maruti Suzuki",
      "model": "Dzire",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1701-1801-00001263",
      "createdAt": "2026-06-02 16:01",
      "user": "ganeshprasad.ap",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1101-1801-00001667",
      "createdAt": "2026-06-02 16:35",
      "user": "ruchinmangla.ext",
      "make": "Mercedes Benz",
      "model": "GLC",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 3,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1503-1825-00000561",
      "createdAt": "2026-06-02 17:00",
      "user": "nithin.d",
      "make": "Kia",
      "model": "Carnival",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2001-1825-00001964",
      "createdAt": "2026-06-02 17:29",
      "user": "akshay.koparde",
      "make": "Maruti Suzuki",
      "model": "Brezza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1704-1825-00000151",
      "createdAt": "2026-06-02 18:07",
      "user": "satish.gondkar",
      "make": "Renault",
      "model": "Megane Sedan",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2001-1870-00001546",
      "createdAt": "2026-06-02 18:36",
      "user": "akshay.koparde",
      "make": "Maruti Suzuki",
      "model": "Ertiga",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1801-1801-00001807",
      "createdAt": "2026-06-02 20:29",
      "user": "radhakrishnak.ext",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1804-1825-00000379",
      "createdAt": "2026-06-03 10:47",
      "user": "bhavanip.rayudu",
      "make": "Volkswagen",
      "model": "Passat",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 45,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1503-1825-00000565",
      "createdAt": "2026-06-03 11:30",
      "user": "jaiganesh.p",
      "make": "Toyota",
      "model": "RAV4",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1501-1801-00000924",
      "createdAt": "2026-06-03 12:22",
      "user": "lokeshkumar.arumug",
      "make": "Hyundai",
      "model": "i20",
      "status": "Completed",
      "uploaded": 13,
      "relevant": 7,
      "partsId": 43,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2001-1870-00001623",
      "createdAt": "2026-06-03 13:04",
      "user": "gaurav.waikar",
      "make": "Tata",
      "model": "Tiago",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1801-1801-00001855",
      "createdAt": "2026-06-03 13:46",
      "user": "raghavendra.battul",
      "make": "Hyundai",
      "model": "Creta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 4,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1101-1870-00001132",
      "createdAt": "2026-06-03 14:44",
      "user": "naveen.kumar07",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2401-1825-00001139",
      "createdAt": "2026-06-03 15:20",
      "user": "swakshar.paladhi",
      "make": "Hyundai",
      "model": "Exter",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2401-1870-00001197",
      "createdAt": "2026-06-03 16:10",
      "user": "swakshar.paladhi",
      "make": "Tata Motors Limited",
      "model": "Harrier",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1302-1870-00000327",
      "createdAt": "2026-06-03 17:14",
      "user": "gaurav.kumar21",
      "make": "MG",
      "model": "Windsor",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1802-1801-00000585",
      "createdAt": "2026-06-03 17:42",
      "user": "naveenkumard.ext",
      "make": "Hyundai",
      "model": "Creta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 3,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1204-1803-00000198",
      "createdAt": "2026-06-03 18:21",
      "user": "chatarpatigupta.ex",
      "make": "Maruti Suzuki",
      "model": "Dzire",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 3,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2203-1801-00001458",
      "createdAt": "2026-06-03 19:50",
      "user": "chitrang.vaniyawal",
      "make": "Peugeot",
      "model": "301",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1102-1825-00001670",
      "createdAt": "2026-06-04 09:34",
      "user": "ashwanit.ext",
      "make": "Maruti Suzuki",
      "model": "Brezza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1804-1801-00000453",
      "createdAt": "2026-06-04 10:57",
      "user": "venkatesh.pedhired",
      "make": "Honda",
      "model": "City",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 29,
      "partsNot": 9,
      "cameras": 5
    },
    {
      "claimId": "OC-27-2202-1825-00000898",
      "createdAt": "2026-06-04 11:36",
      "user": "chaitanya.gohil",
      "make": "Lifan",
      "model": "X60",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 37,
      "partsNot": 4,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1801-1870-00001140",
      "createdAt": "2026-06-04 12:14",
      "user": "lingaswami.kotha",
      "make": "Hyundai",
      "model": "Aura",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 38,
      "partsNot": 5,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1701-1825-00001210",
      "createdAt": "2026-06-04 13:04",
      "user": "nanthakumar.r",
      "make": "Dacia",
      "model": "Logan",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1801-1825-00001158",
      "createdAt": "2026-06-04 13:56",
      "user": "yaramala.bhadraiah",
      "make": "Nissan",
      "model": "Magnite",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 1,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1101-1870-00001169",
      "createdAt": "2026-06-04 15:01",
      "user": "naveen.kumar07",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1701-1825-00001299",
      "createdAt": "2026-06-04 15:49",
      "user": "prabu.d01",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 13,
      "relevant": 6,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1102-1875-00000037",
      "createdAt": "2026-06-04 16:23",
      "user": "ClaimsApp",
      "make": "Tata",
      "model": "Aria",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2201-1870-00000690",
      "createdAt": "2026-06-04 16:57",
      "user": "parth.gupta",
      "make": "Hyundai",
      "model": "Aura",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1101-1801-00001726",
      "createdAt": "2026-06-04 17:35",
      "user": "trilok.negi",
      "make": "Hyundai",
      "model": "Elantra",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1101-1825-00001412",
      "createdAt": "2026-06-04 18:24",
      "user": "aman.verma02",
      "make": "Maruti Suzuki",
      "model": "Brezza",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1205-1870-00000687",
      "createdAt": "2026-06-04 21:29",
      "user": "aijaz.rather",
      "make": "SEAT",
      "model": "Leon",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1602-1801-00000987",
      "createdAt": "2026-06-05 10:53",
      "user": "sujith.k",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2202-1801-00002423",
      "createdAt": "2026-06-05 12:07",
      "user": "chaitanya.gohil",
      "make": "BMW",
      "model": "3 Series",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 7,
      "partsId": 38,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2303-1870-00000146",
      "createdAt": "2026-06-05 13:00",
      "user": "sushant.kamble",
      "make": "Hyundai",
      "model": "Creta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1701-1801-00000978",
      "createdAt": "2026-06-05 13:50",
      "user": "rakshith.bangera03",
      "make": "Volkswagen",
      "model": "Vento",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2303-1825-00000145",
      "createdAt": "2026-06-05 14:51",
      "user": "tushar.namdeo",
      "make": "Mahindra",
      "model": "Thar",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 5,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1701-1870-00000900",
      "createdAt": "2026-06-05 15:25",
      "user": "pradeeparaja.ks",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1701-1803-00001679",
      "createdAt": "2026-06-05 16:01",
      "user": "roshan.m",
      "make": "Maruti Suzuki",
      "model": "Tour S",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1501-1870-00000762",
      "createdAt": "2026-06-05 16:35",
      "user": "aranganathan.g",
      "make": "Audi",
      "model": "A4",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 47,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2203-1801-00001551",
      "createdAt": "2026-06-05 16:53",
      "user": "dhaval.malani",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 44,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1804-1825-00000401",
      "createdAt": "2026-06-05 17:18",
      "user": "krishnasai.reesu",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2201-1870-00000694",
      "createdAt": "2026-06-05 17:42",
      "user": "amit.sharma30",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-27-2202-1801-00002449",
      "createdAt": "2026-06-05 18:17",
      "user": "dhavalshah.ext",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 18,
      "partsNot": 17,
      "cameras": 2
    },
    {
      "claimId": "OC-27-1501-1801-00000972",
      "createdAt": "2026-06-05 18:59",
      "user": "rajeshkhanna.ext",
      "make": "Kia",
      "model": "Seltos",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2204-1870-00000659",
      "createdAt": "2026-06-06 11:02",
      "user": "kishan.chudasama",
      "make": "Hyundai",
      "model": "Grand i10",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1203-1801-00000368",
      "createdAt": "2026-06-06 17:27",
      "user": "piyush.ext",
      "make": "Toyota",
      "model": "Innova Crysta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 37,
      "partsNot": 5,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1602-1825-00000426",
      "createdAt": "2026-06-06 18:00",
      "user": "jetheesh.k",
      "make": "Toyota",
      "model": "Glanza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2001-1825-00002128",
      "createdAt": "2026-06-07 07:39",
      "user": "nitin.khade",
      "make": "Kia",
      "model": "Carens",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1516-1870-00000058",
      "createdAt": "2026-06-08 10:37",
      "user": "udayashanker.e",
      "make": "Honda",
      "model": "City",
      "status": "Completed",
      "uploaded": 11,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1102-1825-00001755",
      "createdAt": "2026-06-08 11:34",
      "user": "amandeep.saini",
      "make": "Kia",
      "model": "Picanto",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2403-1825-00000256",
      "createdAt": "2026-06-08 12:05",
      "user": "ajit.rout",
      "make": "Maruti Suzuki",
      "model": "S-Presso",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 32,
      "partsNot": 7,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1801-1870-00001193",
      "createdAt": "2026-06-08 12:32",
      "user": "lingaswami.kotha",
      "make": "Hyundai",
      "model": "Exter",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 2,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1804-1827-00000052",
      "createdAt": "2026-06-08 13:05",
      "user": "venkatesh.pedhired",
      "make": "Volkswagen",
      "model": "Touran",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1801-1825-00001295",
      "createdAt": "2026-06-08 13:45",
      "user": "harish.thumma",
      "make": "Maruti Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 4,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2401-1870-00001281",
      "createdAt": "2026-06-08 14:30",
      "user": "argha.majumder",
      "make": "Hyundai",
      "model": "Creta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 44,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1701-1803-00001729",
      "createdAt": "2026-06-08 15:06",
      "user": "manikandan.m02",
      "make": "Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1102-1803-00000698",
      "createdAt": "2026-06-08 15:34",
      "user": "surinder01.ext",
      "make": "Mercedes-Benz",
      "model": "C-Class",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1203-1825-00000262",
      "createdAt": "2026-06-08 16:00",
      "user": "bhupinder.ext",
      "make": "Hyundai",
      "model": "i30",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2401-1870-00001306",
      "createdAt": "2026-06-08 16:17",
      "user": "shubhomoy.das",
      "make": "Volkswagen",
      "model": "Polo GT",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 44,
      "partsNot": 1,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1501-1825-00001090",
      "createdAt": "2026-06-08 16:31",
      "user": "chitrarasan.ext",
      "make": "Tata",
      "model": "Altroz",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2202-1801-00002544",
      "createdAt": "2026-06-08 16:51",
      "user": "pankil.modi03",
      "make": "Hyundai",
      "model": "i20",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1205-1870-00000736",
      "createdAt": "2026-06-08 17:15",
      "user": "pawandeep.singh",
      "make": "Hyundai",
      "model": "Venue",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1804-1825-00000409",
      "createdAt": "2026-06-08 17:31",
      "user": "eswarraja.kasi",
      "make": "",
      "model": "",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 4,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1207-1825-00000501",
      "createdAt": "2026-06-08 17:48",
      "user": "pawan.kumar21",
      "make": "Kia",
      "model": "Carens",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 46,
      "partsNot": 1,
      "cameras": 6
    },
    {
      "claimId": "OC-27-2204-1801-00001099",
      "createdAt": "2026-06-08 18:08",
      "user": "vikas.rakholiya",
      "make": "Toyota",
      "model": "Innova Crysta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 46,
      "partsNot": 1,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2201-1870-00000731",
      "createdAt": "2026-06-08 18:32",
      "user": "tirth.kapatel",
      "make": "Hyundai",
      "model": "Creta",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1301-1825-00000370",
      "createdAt": "2026-06-08 18:59",
      "user": "durgesh.tiwari02",
      "make": "Kia",
      "model": "Sonet",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 1,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2001-1825-00002147",
      "createdAt": "2026-06-08 21:59",
      "user": "rushikesh.mane03",
      "make": "Tata",
      "model": "Altroz",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 3,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1501-1870-00000802",
      "createdAt": "2026-06-09 10:09",
      "user": "udayashanker.e",
      "make": "Toyota",
      "model": "Glanza",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2001-1825-00002173",
      "createdAt": "2026-06-09 11:01",
      "user": "rohit.godse",
      "make": "Hyundai",
      "model": "I20",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 1,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1602-1801-00000977",
      "createdAt": "2026-06-09 11:39",
      "user": "thahir.sait01",
      "make": "Kia",
      "model": "Seltos",
      "status": "Failed",
      "uploaded": 14,
      "relevant": 7,
      "partsId": 31,
      "partsNot": 6,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1901-1825-00001198",
      "createdAt": "2026-06-09 12:10",
      "user": "nishant.chettiyar",
      "make": "Tata",
      "model": "Tiago",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 39,
      "partsNot": 2,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1703-1801-00000663",
      "createdAt": "2026-06-09 12:40",
      "user": "yakub.dhandu",
      "make": "Maruti Suzuki",
      "model": "Ignis",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2202-1825-00000999",
      "createdAt": "2026-06-09 13:02",
      "user": "devarshi.patel01",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2001-1801-00002654",
      "createdAt": "2026-06-09 13:30",
      "user": "nitin.khade",
      "make": "Maruti Suzuki",
      "model": "Baleno",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 40,
      "partsNot": 1,
      "cameras": 5
    },
    {
      "claimId": "OC-27-1207-1870-00000521",
      "createdAt": "2026-06-09 14:14",
      "user": "jagmohan.singh02",
      "make": "Tata",
      "model": "Nexon",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 5,
      "partsId": 28,
      "partsNot": 9,
      "cameras": 4
    },
    {
      "claimId": "OC-27-1503-1825-00000625",
      "createdAt": "2026-06-09 14:50",
      "user": "nithin.d",
      "make": "Hyundai",
      "model": "Venue",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 44,
      "partsNot": 3,
      "cameras": 8
    },
    {
      "claimId": "OC-27-2416-1827-00000023",
      "createdAt": "2026-06-09 15:09",
      "user": "vishal.singh21",
      "make": "Mitsubishi",
      "model": "Outlander",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 43,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2201-1801-00001249",
      "createdAt": "2026-06-09 15:32",
      "user": "nileshkumar.bhoi",
      "make": "Hyundai",
      "model": "I20",
      "status": "Completed",
      "uploaded": 15,
      "relevant": 7,
      "partsId": 35,
      "partsNot": 5,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1101-1870-00001237",
      "createdAt": "2026-06-09 15:54",
      "user": "sushil.rajbhar",
      "make": "Tata",
      "model": "Nexon",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 42,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1701-1825-00001400",
      "createdAt": "2026-06-09 16:16",
      "user": "chethan.acharya",
      "make": "Tata Motors Limited",
      "model": "Harrier",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 37,
      "partsNot": 4,
      "cameras": 6
    },
    {
      "claimId": "OC-27-1203-1827-00000096",
      "createdAt": "2026-06-09 16:33",
      "user": "rajinder.choudhary",
      "make": "Maruti Suzuki",
      "model": "Swift",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 7
    },
    {
      "claimId": "OC-27-1101-1825-00001494",
      "createdAt": "2026-06-09 16:50",
      "user": "sushil.rajbhar",
      "make": "Honda",
      "model": "Amaze",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 41,
      "partsNot": 2,
      "cameras": 8
    },
    {
      "claimId": "OC-27-1701-1801-00001452",
      "createdAt": "2026-06-09 17:07",
      "user": "k.kumar02",
      "make": "Maruti Suzuki",
      "model": "Celerio",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 8,
      "partsId": 38,
      "partsNot": 3,
      "cameras": 7
    },
    {
      "claimId": "OC-27-2201-1825-00000790",
      "createdAt": "2026-06-09 17:21",
      "user": "nileshkumar.bhoi",
      "make": "Hyundai",
      "model": "i20",
      "status": "Completed",
      "uploaded": 10,
      "relevant": 6,
      "partsId": 31,
      "partsNot": 9,
      "cameras": 3
    }
  ]
};